export default __webpack_public_path__ + "static/media/Nitroxgallery_5.55513fbb.JPG";